import { AmbulanceTransactionForm } from '../types/form/ambulanceTransactionForm.ts';

interface AmbulanceFormSlice {
    ambulanceFormData: AmbulanceTransactionForm;
    setAmbulanceFormData: (data: Partial<AmbulanceTransactionForm>) => void;
    resetAmbulanceFormData: () => void;
}

// The slice will manage the state for the transaction form
const createAmbulanceFormSlice = (set: any) => ({
    ambulanceFormData: {} as AmbulanceTransactionForm,
    setAmbulanceFormData: (data) =>
        set((state) => ({
            ambulanceFormData: { ...state.ambulanceFormData, ...data },
        })),
    resetAmbulanceFormData: () =>
        set({ ambulanceFormData: {} as AmbulanceTransactionForm }),
});

export { createAmbulanceFormSlice };
export type { AmbulanceFormSlice, AmbulanceTransactionForm };
